import * as React from "react";
import styled from "styled-components";
import { Anchor, Box, Button, FileInput, Text } from "grommet";
import Avatar from "react-avatar";
import md5 from "md5";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Rating from "./Rating";

const AliasHeader = ({ name, email, photoUri, splashUri, rating }) => {
    let number = name && name[0] > "m" ? "1" : "2";

    return (
        <div>
            <Box align="center" pad="medium" background={{ image: `url(${splashUri})`, color: "rgba(0,0,0,0.7)" }} round={{ corner: "bottom", size: "5px" }}>
                <br />
                <Avatar email={!photoUri ? email : ""} name={name} round={"18px"} size="150" src={photoUri}></Avatar>
                <br />
                <Text size={"xlarge"}>{name}</Text>
                <br />
                {/*  <div>
                    <Text size="small">Rookie</Text> <progress max="120" value="100" style={{ width: "270px" }}></progress> <Text size="small">Novice</Text>
                </div>
                <div>
                    <Text size="small" color="brand">
                        You have <strong>100xp</strong> you need <strong>20xp</strong> more to level up
                    </Text>
                </div> */}
                <div>
                    <Rating rating={rating}></Rating>
                </div>
            </Box>
        </div>
    );
};

export default AliasHeader;
